import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const googleIcon = require('./../../assets/googleStorIcon.png'); 
const appStorIcon = require('./../../assets/appStoreIcon.png'); 
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute', 
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    height: 200,
    display: 'flex',
    flexDirection: 'column',
    
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs({opens, handleClose}) {
//   const [open, setOpen] = React.useState(false);

//   const handleClickOpen = () => {
//     setOpen(true);
//   };
//   const handleClose = () => {
//     setOpen(false);
//   };

  return (
    <div>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={opens} >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {/* Modal title */}
        </DialogTitle>
        <DialogContent>
          <Typography style={{fontSize: 15, fontWeight: 500}}>
            If you want watch the video please download the 2thepoint app 
          </Typography>
          <div style={{display: 'flex', flexDirection: 'column', justifyContent:'center',alignItems: 'center', alignSelf: 'center', marginTop: 20}}>
             <a href='https://play.google.com/store/apps/details?id=com.tothepoint' target='blank'
               style={{marginTop: 5}}
             >
               <img src={googleIcon} style={{width: 200, height: 50, }}/>
             </a>
             <a href='https://2thepoint.page.link/appLink' target='blank'
               style={{marginTop: 20}}
             >
               <img src={appStorIcon} style={{width: 200, height: 50}}/>
             </a>
          </div>
        </DialogContent>
       
      </Dialog>
    </div>
  );
}